import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Manifesto: React.FC = () => {
  // Sayfa yüklendiğinde en üste kaydır
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white">
      <div className="bg-odtu-red py-12">
        <div className="container">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center">Manifestomuz</h1>
        </div>
      </div>
      
      <div className="container section">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg mx-auto">
            {/* 1. Kısım: Neden Adayız? */}
            <h2 className="text-2xl font-bold text-odtu-red mb-6">NEDEN ADAYIZ?</h2>
            
            <p className="mb-8">
              ODTÜ mezunları arasındaki bağları güçlendirmek, derneğin bilinirliğini artırmak ve bursiyerlere daha fazla destek sağlamak amacıyla aday oluyoruz. Geçmiş dönemlerden farklı olarak, daha şeffaf, katılımcı ve yenilikçi bir yönetim anlayışı benimsiyoruz.
            </p>
            
            {/* 2. Kısım: İlkelerimiz */}
            <h2 className="text-2xl font-bold text-odtu-red mb-6">İLKELERİMİZ</h2>
            
            <ul className="mb-8 space-y-4">
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Şeffaf ve yalın bir yönetim şeklini uygularız. Gerçekleştirdiğimiz ve planladığımız tüm faaliyetleri üyelerimiz tarafından görülebilir ve anlaşılabilir şekilde net ve açık bir ifadeyle sunmak için çalışırız.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Demokratik katılımı destekler, eşitlikçi, kapsayıcı ve çeşitliliği destekleyici yaklaşımla tüm üyelere ve farklılıklara kapımızı her zaman açık tutarız. Her üyenin fikrinin ve mevcudiyetinin eşit değerde olduğuna inanırız.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Yeni fikirler ve önerilerin, derneğimiz için önemini bilerek hareket eder, bu önerilere kendimizi açık tutarız.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Üyelerle olan iletişimimizde, çevre ile olan iletişimimizde şiddetsiz bir dille iletişime inanırız. Tüm ilişkilerimizde bu doğrultuda hareket eder, derneğin iletişim gruplarında sansürsüz iletişimi destekleyici şekilde çalışırız.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Dernek amaç ve hedeflerine bağlı kalarak, tutarlı bir yol haritasıyla ve kaynakları en verimli şekilde kullanarak hareket ederiz.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Geçmiş yıllarda dernek çalışmalarına katkı veren tüm üyelere vefa gösterir, emeğin değerini gözetiriz. Bir mezun derneği olmanın bilinciyle hatırşinas bir bakış açısıyla çalışırız.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Yönetimin, üyeler için var olduğu anlayışını benimseriz; üyelerin yönetime hizmet etmesi değil, yönetimin üyelere hizmet etmesi bizim için esastır.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Derneğin bilinirliğine ve yaygınlaşmasına katkıda bulunmak, üyeler arası bağlantıları güçlendirebilmek için çalışırız. ODTÜ'lülere alan açar, destek oluruz.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Daha çok öğrenciye burs verebilmek, bursiyerlerin gelişimlerine katkıda bulunabilmek için kaynak yaratmayı amaçlarız.
                </div>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 h-4 w-4 rounded-full bg-odtu-red flex items-center justify-center mr-3 mt-1.5">
                  <span className="text-white text-xs">•</span>
                </div>
                <div>
                  Üye sayısını artırabilmek ve özellikle genç üyelerin daha çok katılımını sağlayabilmek için yeni ve modern teknikleri kullanırız.
                </div>
              </li>
            </ul>
            
            {/* 3. Kısım: Örnek Aksiyonlar */}
            <h2 className="text-2xl font-bold text-odtu-red mb-6">ÖRNEK AKSİYONLAR</h2>
            
            <p className="mb-4">
              Çalışma planlarımız hakkında fikir verebilmek için, aksiyon planımıza ait birkaç örneği görebilirsiniz. Projelerimiz aşağıdaki örneklerle sınırlı olmayacak, çalışma dönemimiz boyunca makul her tür yeni projenin hayata geçirilebilmesi için çalışılacaktır.
            </p>
            
            <h3 className="text-xl font-semibold text-odtu-gray mt-6 mb-3">1. Yeni Üye Katılımı</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Yeni üye seferberliği – Hedef 5 bin!</li>
              <li>Ön/Geçici Üye, Katkı Paylı Üye, Askıda Üyelik gibi üyelik tiplerinin çeşitlendirilmesi</li>
              <li>Şirketlerdeki üst düzey ODTÜ'lülerin birebir ziyaret edilmesi, şirketler bünyesindeki ODTÜ mezunlarının derneğe katılımının teşvik edilmesi</li>
              <li>Özellikle bursiyer öğrenciler mezun olduklarında mutlak surette derneğe üye olmalarının sağlanması, gerekirse ilk 2 yıl dernek üyelik aidatında desteklenmeleri</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-odtu-gray mt-6 mb-3">2. Kaynak Geliştirme Projeleri</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Tanınmış ODTÜ'lülerle söyleşi</li>
              <li>Kitap imza günleri</li>
              <li>Kaliteli ve geniş kapsamlı bir Mezunlar Buluşması etkinliği</li>
              <li>Tanınmış ODTÜ'lülerle akşam yemeği</li>
              <li>Yemek yapım atelyesi</li>
              <li>Maraton çalışmalarının daha katılımcı bir yapıya dönüştürülerek burs miktarının artırılması</li>
              <li>Yurt dışında yaşayan mezunlarla iletişimi artıracak çalışmalar (Ülke temsilciliği, düzenli online etkinlikler,…)</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-odtu-gray mt-6 mb-3">3. Üyeler Arası Bağlantı Geliştirici ve Mevcut Üyelerin Tutundurulmasına Yönelik Aktiviteler</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Üyeler arası networking aktivitesi (Şirketini tanıtmak isteyen ODTÜ'lülerin karşılıklı tanıtım yapabileceği düzenli etkinlikler)</li>
              <li>Şirketlerde üst düzey çalışan ODTÜ'lülerin katılacağı (kendilerini/şirketlerini/hobilerini… anlatabileceği) online düzenli toplantılar</li>
              <li>Dernek faaliyetlerinin (haftalık, aylık,) üyelere düzenli olarak bildirecek bir iletişim altyapısının oluşturulması (Mevcut eposta bildirim sisteminin iyileştirilmesi)</li>
              <li>Özel yetkinliği olan üyelerimizin bu yetkinliklerini dernek üyelerine ve/veya bursiyerlerimize sunma imkanının oluşturulması (özel eğitimler, danışmanlıklar)</li>
              <li>Üyelerimizin hem zor günlerinde (işini kaybetmiş mezunlarımıza kariyer danışmanlığı ve desteğinin sağlanması. Şehir, ülke değişiklik ihtiyaçlarında destek olunması…) yanında olabilmek hem de iyi günlerinde sevinçlerinin paylaşılması (doğum günü kutlamaları, iş terfi kutlamaları, doğum, evlenme gibi özel günlerinde yanlarında olunması)</li>
              <li>Dernekçe alınması gereken hizmetlerin üyelere de duyurularak, iyi ve kaliteli hizmeti, en uygun fiyata alırken ODTÜ mezunu üyelerimize fayda sağlanması</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-odtu-gray mt-6 mb-3">4. İletişim Stratejisine Yönelik Aktiviteler</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Dernek web sitesinin modern bir altyapıya taşınması, burs havuzuna faydası dokunan e-kartların çeşitlendirilmesi ve görsellerin güncellenmesi</li>
              <li>Sosyal medyanın, derneğin iletişim stratejisinin bir parçası olduğu bilinciyle farklı kanallarda farklı kitlelere hitap edildiğinin farkında olarak uygulanması</li>
              <li>Tüm iletişim kanallarında ODTÜ'ye yakışır, profesyonel üslupla hareket edecek mekanizmalar kurulması</li>
              <li>Diğer ODTÜ Mezun dernekleriyle iletişimin güçlendirilmesi, konseyin tekrar etkin bir şekilde hayata geçirilmesi</li>
              <li>Diğer mezun dernekleriyle bağlantıların sağlanması ve geliştirilmesi</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-odtu-gray mt-6 mb-3">5. Bursiyerlere Yönelik Aktiviteler</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Eski bursiyerlerin dernek komitelerinde görev almalarının sağlanması, bu bağlamda tüm üyelerde motivasyon artırılabilmesine yönelik aktivitelerin hayata geçirilmesi</li>
              <li>Köprü grubundaki öğrencilerin kendi arzu ettikleri farklı projeler geliştirmelerine destek olarak daha aktif katılımlarının sağlanması</li>
              <li>Bursiyerlerimiz için staj imkânı sağlayacak yapısal bir sistemin oluşturulması</li>
              <li>Bursiyerlerimize kariyer planlama desteğinin sağlanması</li>
              <li>ODTÜ öğrencilerinin derslerinde destek olmak üzere bir uzman havuzu oluşturulması ve bursiyer olsun, olmasın ihtiyaç duyan öğrencilere destek olunması</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-odtu-gray mt-6 mb-3">6. Dernek Yönetim Altyapısına Yönelik Aktiviteler</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Derneğimize ait kolay ulaşılabilen kalıcı bir yerleşkenin alınması için kaynak oluşturma çalışmalarının başlatılması</li>
              <li>Derneğimizin sürdürülebilirliğini sağlayacak ve kurumsal hafızasını oluşturacak yönetim altyapılarının oluşturulması (Insan, Süreç, Teknoloji)</li>
            </ul>
            
            <p className="mb-8">
              <Link to="/candidates" className="text-odtu-red hover:underline font-medium">
                Aday listesini görmek için tıklayın
              </Link> veya <a href="https://www.linkedin.com/company/odtuluyuzbiz" target="_blank" rel="noopener noreferrer" className="text-odtu-red hover:underline font-medium">
                LinkedIn sayfamızı ziyaret edin
              </a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manifesto;